import { qportalApi } from './qportal-api';
const getUsers = (request) => {
    const filter = `&filter=${request.filter ? request.filter : ''}`;
    return qportalApi.get(`users?pageNumber=${request.pageNumber}&pageSize=${request.pageSize}${filter}`);
};
const getUserById = (userId) => {
    return qportalApi.get(`users/${userId}/profile`);
};
const getUserByStatus = (status) => {
    return qportalApi.get(`users/${status}/getUsersByStatus`);
};
const updateUser = (userId, user) => {
    user.status = Number(user.status);
    return qportalApi.put(`users/${userId}/update`, user);
};
const disableUser = (userId) => {
    return qportalApi.put(`account/disable/${userId}`);
};
const enableUser = (userId) => {
    return qportalApi.put(`account/enable/${userId}`);
};
const getUserByEmail = (email) => {
    return qportalApi.get(`users/GetUserByEmail/${email}`);
};
const getCurrentUser = () => {
    return qportalApi.get(`users/profile`);
};
const getAdminAndSuperAdminUsers = () => {
    return qportalApi.get(`users/adminAndSuperAdmin`);
};
const UserApi = {
    getUsers,
    getUserById,
    getUserByStatus,
    updateUser,
    disableUser,
    enableUser,
    getUserByEmail,
    getCurrentUser,
    getAdminAndSuperAdminUsers
};
export default UserApi;
